import { getRGBColor } from '@elfsight/widget-utils';

const DARK_COLOR = 'rgb(17, 17, 17)';
const LIGHT_COLOR = 'rgb(255, 255, 255)';
const BRIGHTNESS_THRESHOLD = 156;

const RED_WEIGHT = 0.299;
const GREEN_WEIGHT = 0.587;
const BLUE_WEIGHT = 0.114;

function parseRGB(color) {
  const result = color.match(/\d+/g);

  return result?.map(Number) || null;
}

function calculateBrightness(rgb) {
  const [r, g, b] = rgb;

  return RED_WEIGHT * r + GREEN_WEIGHT * g + BLUE_WEIGHT * b;
}

export function getSecondColor({
  backgroundType,
  backgroundColor,
  backgroundImageOverlayColor
}) {
  const isValidBackground =
    backgroundType === 'image' ||
    (backgroundType === 'color' && backgroundColor !== 'transparent');

  if (isValidBackground) {
    const rgbColor =
      backgroundType === 'image'
        ? getRGBColor(backgroundImageOverlayColor)
        : getRGBColor(backgroundColor);
    const rgb = parseRGB(rgbColor);

    return calculateBrightness(rgb) > BRIGHTNESS_THRESHOLD
      ? DARK_COLOR
      : LIGHT_COLOR;
  }

  return DARK_COLOR;
}
